import {Button, H2, Loading, Tab, TabsPanel} from '@hm/fundamental'
import {mdiTrayArrowDown} from '@mdi/js'
import {useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {useFiltersContext} from '../../providers/FiltersProvider'

import {InstallationsTable} from './InstallationsTable'
import {KilnsReportTable} from './KilnsReportTable'

import {buildReportPayload} from '@refra/modules/refra-flexible-report/helpers'
import {FiltersFormValues} from '@refra/modules/refra-flexible-report/types'

enum ReportTab {
  Kilns = 'kilns',
  Installations = 'installations'
}

export const Report = () => {
  const {t} = useTranslation()
  const {getValues} = useFormContext<FiltersFormValues>()
  const {report, filteredKilns, isExporting, exportReport} = useFiltersContext()
  const [activeTab, setActiveTab] = useState(ReportTab.Kilns)
  const hasReportData = (report?.materialInstallations?.length ?? 0) > 0
  const hasReportResponse = report !== undefined

  const handleSelect = (value: string) => {
    setActiveTab(value as ReportTab)
  }

  const showInstallations = activeTab === ReportTab.Installations && hasReportResponse

  const handleExport = async () => {
    await exportReport(buildReportPayload(getValues(), filteredKilns))
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <H2>{t('refraFlexibleReport.report.title')}</H2>

        {showInstallations && hasReportData && (
          <Button
            variant="tertiary"
            icon={isExporting ? <Loading size="xsmall" variant="primary" /> : mdiTrayArrowDown}
            iconPosition="left"
            onClick={handleExport}
            disabled={isExporting}
            data-cy="refra_export_report_btn"
          >
            {t('common.export')}
          </Button>
        )}
      </div>
      <TabsPanel onSelect={handleSelect}>
        <Tab
          label={t('refraFlexibleReport.report.kilnsSection.title')}
          value={ReportTab.Kilns}
          isActive={!showInstallations}
        />
        {hasReportResponse && (
          <Tab
            label={t('refraFlexibleReport.report.installationsSection.title')}
            value={ReportTab.Installations}
            isActive={showInstallations}
          />
        )}
      </TabsPanel>
      <div className="pt-4">
        {showInstallations ? <InstallationsTable /> : <KilnsReportTable />}
      </div>
    </div>
  )
}
